import { TitleWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { CollectionTitle } from '@src/pages/[...slug]/components/collection/molecules/collectionTitle'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { GetSeoMetapageDataProps } from '@src/quince-site-common/src/utils/seo/getSeoMetadata'

import { usePLPageMeta } from '../../pl-page-context'

import styles from './collection-title.module.scss'

// TODO(@prateekbh) This sucks but If i touch this god knows what'll break!!!!
// but further styles should go to its own module
// import styles from "../breadcrumbs/breadcrumbs.module.scss";

export function TitleWidgetLegacy({ data }: PLTypedWidgetProps<TitleWidgetData>) {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP
  const pageMeta = usePLPageMeta()
  // Prefer the title carried by the TITLE widget payload (PL may return a
  // subcollection-specific title here), and fall back to the page-level meta
  // title when the widget does not provide one.
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty strings from proto3 defaults should also fall back to pageMeta.title
  const resolvedTitle = data.titleData?.text || pageMeta.title || ''
  return (
    <div className={styles.title_container}>
      <div className={isDesktop ? styles.container__text : ''}>
        <CollectionTitle
          title={resolvedTitle}
          hideCollectionPageTitle={false}
          isRootCollectionPage={false}
          isJumpLink={false}
          // Do not forward widgetData.text as subCollectionTitle: in PL this string equals
          // meta.title (the H1/display title), so passing it triggers CollectionTitle's
          // dynamic SeoPageRouter (gated by `subCollectionTitle && experiment active`) on
          // the second render and overrides the <title> with meta.title instead of the
          // SEO title from meta.seoData.title. Dynamic subcollection-title-on-filter for
          // PL is tracked separately and intentionally deferred.
          subCollectionTitle={undefined}
          seoData={pageMeta.seoData as GetSeoMetapageDataProps | null}
          alternateUrls={{}}
          offerMessage={undefined}
        />
      </div>
    </div>
  )
}
